import * as Yup from 'yup';
import { SPHL } from '@models';

export function useValidationSchema() {
  return Yup.object<SPHL>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<SPHL>;
}
